module.exports = __webpack_public_path__ + "static/media/1.83963ad4.jpg";